<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card color="green" title="Add Subject" text="Select course, subject and type chapter name and hit submit">
      <v-form
      ref="chapterFrom"
      v-model="valid"
      lazy-validation
      >
          <v-select
            :items="courseList"
            label="Select Course"
            item-text="name"
            item-value="id"
            v-model="chapter.course_id"
            class="mt-4"
            @change="onSelectCourse(chapter.course_id)"
            :rules="courseIDRules"
          ></v-select>
          <v-select
            :items="courseSubjectList"
            label="Select Subject"
            item-text="name"
            item-value="id"
            v-model="chapter.subject_id"
            class="mt-4"
            :rules="subject_IDRules"
            @change="onSelectSubject(chapter.course_id, chapter.subject_id)"
          ></v-select>
          <v-text-field
            label="Chapter name"
            name="chapter_name"
            class="green-input"
            v-model="chapter.name"
            :rules="chapterNameRules"
          />
          <v-flex xs12 text-xs-right>
            <v-btn class="mx-0 font-weight-light" color="success" @click="onSubmitChapter">Submit</v-btn>
          </v-flex>
      </v-form>

        </material-card>
      </v-flex>
      <v-flex xs12 md6>
        <material-card
          color="green"
          title="Chapter List"
          text="All chapters"
        >
          <!-- {{ courseDetails.name }} -->
          <v-data-table :headers="headers" :items="chapterList" >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.name }}</td>
            </template>
          </v-data-table>
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  metaInfo() {
    return {
      title: "Course Details | Admin"
    };
  },
  components: {},
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState("course_subjects", [
      "courseList",
      "courseSubjectList",
      "subjectListNotInCourse",
      "courseDetail",
      "chapterList"
    ])
  },
  mounted() {
    this.getcourselist();
    this.getCourseSubjectList(this.$route.params.id);
    this.getCourseDetails(this.$route.params.id);
    // this.getSubjectListNotInCourse(this.$route.params.id)
  },
  data() {
    return {
      valid: true,
      color: null,
      chapter: {},
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      headers: [
        {
          sortable: true,
          text: "Chapter",
          value: "name"
        }
      ],
      dialog: false,
      noticeMessage: "",
      valueObj: {},
      chapterNameRules: [
        v => !!v || "Chapter is required",
        v =>
          (v && v.length <= 30) || "First name must be less than 30 characters"
      ],
      subject_IDRules: [
        v => !!v || "Please select subject",
      ],
      courseIDRules :[
        v => !!v || "Please select subject",
      ]
    };
  },
  created() {},
  methods: {
    ...mapActions("course_subjects", [
      "fetchData",
      "CreateCourse",
      "getcourselist",
      "getCourseSubjectList",
      "getSubjectListNotInCourse",
      "addSubjectToCourse",
      "getCourseDetails",
      "getChapterNameListBySubjectId",
      "storeChapter"
    ]),

    onSelectCourse(course_id) {
      this.chapter.subject_id = null;
      this.$refs.chapterFrom.resetValidation()
      this.getCourseSubjectList(course_id);
    },
    onSelectSubject(course_id, subject_id) {
    let obj = {
      courseId : course_id,
      subjectId : subject_id
    }
      this.getChapterNameListBySubjectId(obj);
    },
    onSubmitChapter() {
      if (this.$refs.chapterFrom.validate()) {
      this.storeChapter(this.chapter).then(response => {
        console.log(response)
        if (response.status == "OK") {
          
          let obj = {
            courseId : this.chapter.course_id,
            subjectId : this.chapter.subject_id
          }
          this.chapter.name = null
          this.$refs.chapterFrom.resetValidation()
          this.getChapterNameListBySubjectId(obj);
          this.color = "success";
          this.subject_id = null;
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      });
      } else {
        console.log('failed')
      }
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      //   this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true;
    }
  }
};
</script>
